import React from "react";

const icons = {
  success: (
    <svg className="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
    </svg>
  ),
  warning: (
    <svg className="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
    </svg>
  ),
  error: (
    <svg className="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
    </svg>
  ),
};

const styles = {
  success: {
    wrapper: "bg-statusGreenBg border-l-4 border-statusGreen text-statusGreen",
    text: "text-green-800",
  },
  warning: {
    wrapper: "bg-statusOrangeBg border-l-4 border-statusOrange text-statusOrange",
    text: "text-orange-800",
  },
  error: {
    wrapper: "bg-statusRedBg border-l-4 border-statusRed text-statusRed",
    text: "text-red-800",
  },
};

const SystemBanner = ({ type = "success", message, action }) => {
  const s = styles[type] || styles.success;
  return (
    <div className={`w-full flex items-center justify-between gap-3 px-4 py-3 rounded-lg mb-4 ${s.wrapper}`}>
      <div className={`flex items-center gap-2 ${s.text}`}>
        {icons[type]}
        <span className="text-sm font-medium">{message}</span>
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
};

export default SystemBanner;
